module.exports = __webpack_public_path__ + "static/asparagus-131d7ad22e1b2423a7bad943ed576c0d.svg";